export default __webpack_public_path__ + "static/media/9C4A7179-a.85a32d8a.jpg";